type MetaStandardEvent = 'Lead'

type PostMessagePayloadForMetaPixelEvent = {
  type: 'META_PIXEL_EVENT'
  event: MetaStandardEvent
  source: 'iframe'
}

const isInIframe = () => window.self !== window.top

export const trackMetaEvent = (event: MetaStandardEvent) => {
  if (!isInIframe()) return

  const message: PostMessagePayloadForMetaPixelEvent = {
    type: 'META_PIXEL_EVENT',
    event,
    source: 'iframe',
  }

  window.parent.postMessage(message, '*')
}
